export default "__VITE_ASSET__CMqA0wJo__"